import { createContext } from "react";

type ContainerBoundaryContextValue = HTMLElement;

/**
 * Context to hold an element of the containing drawer/modal/window for access in components
 * that require a portal, such as popovers. If the value of the context is null, then that implies
 * that we're at the root level and can safely fallback to window or document.body depending on the
 * use case.
 */
const ContainerBoundaryContext = createContext<ContainerBoundaryContextValue>(window.document.body);

export default ContainerBoundaryContext;
